import debounce from 'lodash.debounce';

const Search = () => {
    const searchInput = document.getElementById('posts-search');
    if (searchInput !== null) {
        const searchContent = document.getElementById('posts-search-results');
        const searchGlass = document.querySelector('.posts-search__glass');
        const loader = document.querySelector('.posts-search__loader');
        const searchData = new FormData();
        searchData.append('action', 'search_products');

        searchInput.addEventListener('input', debounce(() => {
            if (searchInput.value.length >= 3) {
                searchData.append('phrase', searchInput.value);
                loader.classList.remove('hidden');
                searchGlass.classList.add('hidden');

                fetch(window.settings.ajaxurl, {
                    method: 'POST',
                    body: searchData,
                })
                    .then(response => response.json())
                    .then(data => {
                        loader.classList.add('hidden');
                        searchGlass.classList.remove('hidden');

                        if (!data.found_products.length > 0 || data.found_products[0].no_found) {
                            searchContent.innerHTML = '<li>Brak wyników</li>';

                        } else {
                            searchContent.innerHTML = data.found_products.map(item => {
                                return `<li class="mb-8">
                          <a href="${item.permalink}" class="grid gap-4 items-center">
                            <div>
                              ${item.thumbnail} 
                            </div>
                            <div>
                              <h5>${item.title}</h5>
                              ${item.price}
                            </div>
                          </a>
                        </li>`;
                            }).join('');
                        }
                    })
                    .catch(error => {
                        console.error('An error occurred:', error);
                    });
            }
        }, 150));
    }
};

export default Search;


